<template>
  <div>
    <h1 style="margin-bottom: 24px;">Кенга Фонд</h1>
    
    
    <!--<div class="social-links">
      <a href="https://t.me/alanverne" target="_blank">Telegram</a>
      <a href="https://instagram.com/al.verne/" target="_blank">Instagram</a>
      <a href="https://facebook.com/alan.verne.v/" target="_blank">Facebook</a>
    </div>-->
    
    <div class="block">
      <h3>Рецепты!</h3>
      <router-link to="/food/carbonara">Карбонара</router-link>
    </div>
    
    
    <div class="papers block">
      <h3>Блог</h3>
      <router-link to="/love/base">Любовь</router-link>,
      <router-link to="/papers/2">Прощай</router-link>,
      <router-link to="/kids/little-racoon">Крошка енот</router-link>,
      <router-link to="/products/sun-wood-tower">Свет</router-link>,
      <router-link to="/papers/1">Выгорание</router-link>.
    </div>
    
    
    <div class="questions block">
      <h3>Творцам</h3>
      Для предпринимателей, стартаперов, программистов, дизайнеров, художников...
      <!--      <div style="margin-bottom: 24px;">Ещё поводы для знакомства</div>-->
      <!--    <router-link to="/naprofe">Что там на Профе?</router-link>-->
      <router-link to="/wanna/startup">Менторство</router-link>,
      <router-link to="/wanna/audit">Аудит архитектуры</router-link>,
      <router-link to="/wanna/codereview">Код-ревью</router-link>,
      <router-link to="/burnoutconsulting">Помощь при выгорании</router-link>.
      <!--    <router-link to="/city">Ты строишь город?</router-link>-->
    </div>


    <div class="trainings block block-last">
      <h3>Ментальный Рост</h3>
      Консультирую. Разрабатываю свою методику ментального роста.
      Собираю встречи клуба процветания ПИ.
      Провожу тренинги <b>«LevelUp»</b>, вмешиваю туда йогу и актёрку.
      Они про знакомство с&nbsp;собой,
      <router-link to="/levelupatprofa/2">предками,</router-link>&nbsp;страхами,
      <router-link to="/leveluppublic/3">раскрепощение,</router-link>
      новые шаблоны поведения,
      <router-link to="/levelupatprofa/1">групповую динамику,</router-link>
      практики расширения внимания.
      <div class="social-links">
        <router-link to="/pi/invite">Клуб ПИ</router-link>
        <router-link to="/wanna/coaching">Индивидуально</router-link>
        <router-link to="/leveluppublic/invite">LevelUp</router-link>
      </div>
    </div>
    
    
    <h3>Об авторе</h3>
    <div style="margin-top: 24px;">
      
      <router-link to="past">В&nbsp;прошлом</router-link>
      влюбился в&nbsp;океан, кодил ночами стартапы, путешествовал с 2 сумками и электрухой.
      <router-link to="present">А&nbsp;сейчас</router-link>:
      люблю мотоцикл, вкусно готовить, петь, боксирую, и что-то назревает очень интересное.
    </div>

  </div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style lang="scss" scoped>
.questions {
  a {
    //display: block;
    //margin-top: 8px;
  }
}

.trainings {
  a {
    //margin-left: 8px;
  }

  a.block {
    display: block;
    margin-top: 24px;
  }
}

.social-links {
  margin-top: 24px;

  a {
    margin-right: 16px;
    white-space: nowrap;
  }
}

.block {
  margin-top: 96px;
}
.block-last {
  margin-bottom: 128px
}
</style>
